import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, FilterItem, UseFiltersResult } from "@/modules/common/filters";
import { ListAdminKnowledgeBaseDto } from "@/service/dto/admin-knowledge-base";

import {
  KNOWLEDGE_BASE_AUDIENCE_OPTIONS,
  KNOWLEDGE_BASE_CATEGORY_OPTIONS,
  KNOWLEDGE_BASE_STATUS_OPTIONS,
  KNOWLEDGE_BASE_TYPE_OPTIONS,
  KnowledgeBaseSortField,
} from "../constants";
import { KNOWLEDGE_BASE_FILTER_FIELDS } from "../filter-fields";

const KNOWLEDGE_BASE_SORT_OPTIONS = [
  { field: KnowledgeBaseSortField.TITLE, label: "Título" },
  { field: KnowledgeBaseSortField.UPDATED_AT, label: "Data de atualização" },
  { field: KnowledgeBaseSortField.CREATED_AT, label: "Data de criação" },
  { field: KnowledgeBaseSortField.PUBLISHED_AT, label: "Data de publicação" },
];

type MultipleFilterKey = "categories" | "types" | "audiences" | "statuses";

const INLINE_FILTERS: { key: MultipleFilterKey; placeholder: string; options: FilterItem[] }[] = [
  { key: "categories", placeholder: "Categoria", options: KNOWLEDGE_BASE_CATEGORY_OPTIONS },
  { key: "types", placeholder: "Tipo", options: KNOWLEDGE_BASE_TYPE_OPTIONS },
  { key: "audiences", placeholder: "Público", options: KNOWLEDGE_BASE_AUDIENCE_OPTIONS },
  { key: "statuses", placeholder: "Status", options: KNOWLEDGE_BASE_STATUS_OPTIONS },
];

interface KnowledgeBaseFilterBarProps {
  filters: UseFiltersResult<ListAdminKnowledgeBaseDto>;
  sort: SortDropdownValue<KnowledgeBaseSortField> | null;
  onSortChange: (sort: SortDropdownValue<KnowledgeBaseSortField> | null) => void;
}

const KnowledgeBaseFilterBar = ({ filters, sort, onSortChange }: KnowledgeBaseFilterBarProps) => (
  <EntityFilterBar
    filters={filters}
    sort={sort}
    onSortChange={onSortChange}
    sortOptions={KNOWLEDGE_BASE_SORT_OPTIONS}
    filterFields={KNOWLEDGE_BASE_FILTER_FIELDS}
    modalTitle="Filtrar Conteúdos"
    searchPlaceholder="Pesquisar por título"
  >
    {INLINE_FILTERS.map(({ key, placeholder, options }) => (
      <FilterBar.Item key={key}>
        <SelectV2
          mode="multiple"
          placeholder={placeholder}
          options={options}
          value={filters.values[key]?.map(String) ?? []}
          onChange={(next) => filters.setValue(key, next.length ? next.map(Number) : undefined)}
        />
      </FilterBar.Item>
    ))}
  </EntityFilterBar>
);

export default KnowledgeBaseFilterBar;
